import { render, staticRenderFns } from "./admin-dashboard.vue?vue&type=template&id=6d5ee1fe&"
import script from "./admin-dashboard.vue?vue&type=script&lang=js&"
export * from "./admin-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./admin-dashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports